<template>
  <div class="chat-input-container">
    <div class="chat-input-message-box">
      <b-input-group class="chat-input-group">
        <b-input-group-prepend is-text>
          <span class="chat-input-options" @click="openAttachModal">
            <i class="fas fa-paperclip" />
          </span>
          <!--<span class="chat-input-options" @click="openAttachModalBot">
            <i class="fas fa-rocket" />
          </span> -->
          <!-- <span class="chat-input-options" @click="openAttachModalAudio">
            <i class=" fa fa-microphone" />
          </span> -->

        </b-input-group-prepend>
        <b-form-textarea v-model="message" placeholder="Digite sua mensagem" rows="4" max-rows="4" no-resize
          :disabled="disabled" @keyup.shift.enter.prevent="handleShiftEnterKey"
          @keyup.enter.prevent.stop="handleEnterKey" />
        <b-input-group-append is-text>
          <span class="chat-input-options">
            <i class="fas fa-arrow-right" :class="{ 'selected': !isEmptyMessage() }" @click="sendMessage" />
          </span>
        </b-input-group-append>
      </b-input-group>
    </div>
    <b-modal ref="modal-new" v-model="showModal" title="Anexar Arquivo">
      <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop" :style="isDragging && 'border-color: green'">
        <input type="file" name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"
          accept=".pdf,.jpg" hidden="true"/>
        <label for="fileInput" class="file-label">
          <div v-if="isDragging">Solte o arquivo!</div>
          <div v-else>Arraste o arquivo aqui ou <u>Clique aqui</u> para o subir o arquivo.</div>
        </label>
        <div class="preview-container mt-4" v-if="files.length">
        <div v-for="file in files" :key="file.name" class="preview-card">
          <div>
           <p>
              {{ file.name }}
            </p>
          </div>
          <div>
            <button
              class="ml-2"
              type="button"
              @click="remove(files.indexOf(file))"
              title="Remove file"
            >
              <b>×</b>
            </button>
          </div>
        </div>
      </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="handleFileUpload" v-b-tooltip.hover :title="'Enviar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none">Enviar</span></button>
        </div>
      </template>
    </b-modal>
    <b-modal ref="modal-new" v-model="showModalAudio" title="Audio">
      <div class="frame">
        <input type="checkbox" name="toggle" id="record-toggle" @change="toggleRecording">
        <svg viewBox="0 0 100 100">
          <circle cx="50%" cy="50%" r="45" class="circle-svg" />
        </svg>
        <div class="mic">
          <div class="mic__head"></div>
          <div class="mic__neck"></div>
          <div class="mic__leg"></div>
        </div>
        <div class="recording">
          <div class="round"></div>
          <div class="round"></div>
          <div class="round"></div>
        </div>
        <label for="record-toggle" class="toggle-label"></label>
      </div>
      <audio id="audioPlayback" controls></audio>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="sendAudio" v-b-tooltip.hover :title="'Enviar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none">Enviar</span></button>
        </div>
      </template>
    </b-modal>
    <b-modal ref="modal-new" v-model="showModalBot" title="Bots">
      <label for="bot-select">Selecione um robo para atualizar:</label>
      <b-form-select id="bot-select" v-model="botSelected" :options="bots"></b-form-select>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="sendBot" v-b-tooltip.hover :title="'Enviar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none">Enviar</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'ChatInput',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      message: '',
      showModal: false,
      showModalAudio: false,
      showModalBot: false,
      botSelected: '',
      isDragging: false,
      files: [],
      mediaRecorder: null,
      audioChunks: [],
      base64Audio: '',
      bots: [
      ]
    }
  },
  computed: {
    recordingButtonText () {
      return this.isRecording ? 'Parar Gravação' : 'Iniciar Gravação'
    }
  },
  watch: {
    files: {
      handler (newFiles) {
        console.log(newFiles)
      },
      deep: true
    },
    disabled (value) {
      if (value) {
        this.message = ''
      }
    }
  },
  methods: {
    async toggleRecording () {
      if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
        this.mediaRecorder.stop()
      } else {
        const stream = await navigator.mediaDevices.getUserMedia({audio: true})
        this.mediaRecorder = new MediaRecorder(stream)
        this.mediaRecorder.ondataavailable = event => {
          this.audioChunks.push(event.data)
        }
        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks)
          const reader = new FileReader()
          reader.onloadend = () => {
            this.base64Audio = reader.result.split(',')[1]
          }
          reader.readAsDataURL(audioBlob)
          const audioUrl = URL.createObjectURL(audioBlob)
          const audio = document.getElementById('audioPlayback')
          audio.src = audioUrl
          this.audioChunks = []
        }
        this.mediaRecorder.start()
      }
    },
    handleShiftEnterKey (event) {
      if (event.keyCode === 13 && event.shiftKey) {
        event.preventDefault()
        this.message += '\n'
      }
    },
    generateURL (file) {
      let fileSrc = URL.createObjectURL(file)
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc)
      }, 1000)
      return fileSrc
    },
    remove () {
      this.files = []
    },
    handleEnterKey (event) {
      event.preventDefault()

      if (event.keyCode === 13 && !event.shiftKey) {
        this.sendMessage()
      }
    },
    handleFileUpload () {
      const filePromises = []
      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })
      }
      Array.from(this.files).forEach((file) => {
        filePromises.push(readFileAsBase64(file))
      })
      Promise.all(filePromises)
        .then((base64Contents) => {
          this.files.forEach((file, index) => {
            const fileInfo = {
              fileName: file.name,
              mimeType: file.type,
              fileBase: base64Contents[index].split('base64,')[1]
            }
            if (file.type === 'application/pdf') {
              fileInfo.type = 'document'
              this.remove()
              this.sendArchive(fileInfo)
            } else if (file.type === 'image/jpg' || file.type === 'image/jpeg') {
              fileInfo.type = 'image'
              this.remove()
              this.sendImage(fileInfo)
            }
          })
        })
    },

    isEmptyMessage () {
      let message = this.message
      if (_.isNil(message) || !_.isString(message)) return true

      message = _.trimEnd(message)

      return _.isEmpty(message)
    },
    sendMessage () {
      if (this.isEmptyMessage()) return

      const message = {
        text: this.message,
        type: 'text'
      }

      this.$emit('sendMessage', message)

      this.$nextTick(() => {
        this.message = ''
      })
    },
    sendArchive (archive) {
      this.$emit('sendArchive', archive)
    },
    sendImage (image) {
      this.$emit('sendImage', image)
    },
    sendAudio () {
      const fileInfo = {
        type: 'ptt',
        fileBase: this.base64Audio
      }
      this.$emit('sendAudio', fileInfo)
    },
    sendBot () {
      if (this.botSelected === '' || this.botSelected === null) {
        this.$bvToast.toast('Selecione um bot para ativar', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        return
      }
      this.showModalBot = false
      const botInfo = {
        botId: this.botSelected
      }
      this.$emit('sendControllerBot', botInfo)
      this.sendUpdateOperator()
    },
    sendUpdateOperator () {
      const message = {
        username: null,
        nameOperator: 'BOT',
        event: 'transferir',
        description: 'Ativando o bot ' + this.botSelected
      }
      this.$emit('sendUpdateOperator', message)
    },
    openAttachModal () {
      this.showModal = true
    },
    openAttachModalAudio () {
      this.showModalAudio = true
    },
    openAttachModalBot () {
      this.showModalBot = true
    },
    onChange () {
      this.files.push(...this.$refs.file.files)
    },
    dragover (e) {
      e.preventDefault()
      this.isDragging = true
    },
    dragleave () {
      this.isDragging = false
    },
    drop (e) {
      e.preventDefault()
      this.$refs.file.files = e.dataTransfer.files
      this.onChange()
      this.isDragging = false
    },
    async startRecording () {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.mediaRecorder = new MediaRecorder(stream)
        this.mediaRecorder.ondataavailable = event => {
          this.audioChunks.push(event.data)
        }
        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/ogg' })
          this.audioChunks = []
          this.convertBlobToBase64(audioBlob)
        }
        this.mediaRecorder.start()
        this.isRecording = true
      } catch (error) {
        console.error('Erro ao iniciar gravação:', error)
      }
    },
    stopRecording () {
      if (this.isRecording) {
        this.mediaRecorder.stop()
        this.isRecording = false
      }
    },
    convertBlobToBase64 (blob) {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        this.audioData = reader.result
      }
    },
    playAudio () {
      if (this.audioData) {
        const audio = new Audio(this.audioData)
        audio.volume = this.volume
        audio.play()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  %pseudo {
    content: '';
    display: inline-block;
  }

  %absolute-center {
    position: absolute;
    top: 50%;
    left: 50%;
  }

  .frame {
    position: relative;
    top: 100%;
    left: 35%;
    width: 120px;
    height: 140px;
    border-radius: 2px;
    overflow: hidden;
    color: #333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  input { display: none; }

  $circle-size: 115px;
  $stroke-color:#04a791;
  svg {
    @extend %absolute-center;
    width: $circle-size;
    height: $circle-size;
    margin-top: $circle-size * -0.5;
    margin-left: $circle-size * -0.5;
    .circle-svg {
      stroke: $stroke-color;
      stroke-width: 3;
      fill: transparent;
    }
  }

  $mic-size: 75px;
  $mic-color: linear-gradient(45deg, #107670 50%, rgb(32, 151, 164) 50%);
  .mic {
    width: $mic-size;
    height: $mic-size;
    @extend %absolute-center;
    margin-top: $mic-size * -0.5;
    margin-left: $mic-size * -0.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    &__head {
      background: $mic-color;
      width: $mic-size * 0.3;
      width: 30px;
      height: $mic-size * 0.75;
      border-radius: 30px;
      &::after {
        @extend %pseudo;
        @extend %absolute-center;
        top: 10%;
        background: cadetblue;
        width: 8px;
        height: 20px;
        border-radius: inherit;
        transform: translate(-50%);
      }
    }
    &__neck {
      background: $mic-color;
      width: $mic-size * 0.05;
      height: $mic-size * 0.2;
    }
    &__leg {
      background: $mic-color;
      width: $mic-size * 0.3;
      height: $mic-size * 0.05;
      border-radius: 50px;
    }
  }

  .recording {
    @extend %absolute-center;
    width: $mic-size;
    height: $mic-size;
    margin-top: $mic-size * -0.5;
    margin-left: $mic-size * -0.5;
    transform: scale(0.5);
    opacity: 0;
    transition: all 0.3s 0s ease;
  }
  .round {
    $round-size: $mic-size * 0.15;
    @extend %absolute-center;
    background: #04a791;
    width: $round-size;
    height: $round-size;
    border-radius: 50%;
    margin-top: $round-size * -0.5;
    margin-left: $round-size * -0.5;
    animation: recording 1s ease-in-out infinite;
    box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.15);
    &:first-child { left: 20%; }
    &:nth-child(2) { animation-delay: 0.15s; }
    &:last-child {
      left: 80%;
      animation-delay: 0.3s;
    }
  }

  .toggle-label {
    @extend %absolute-center;
    display: inline-block;
    width: $circle-size;
    height: $circle-size;
    margin-top: $circle-size * -0.5;
    margin-left: $circle-size * -0.5;
    cursor: pointer;
  }

  #audioPlayback  {
    position: relative;
    left: 15%;
    margin-top: 30px;
  }

  #record-toggle:checked {
    ~ svg {
      animation: spinning 3s ease-in-out infinite alternate;
      .circle-svg {
        stroke-dasharray: 300;
        stroke-dashoffset: 300;
        animation: dash 3s ease-in-out infinite alternate;
      }
    }

    ~ .mic {
      transform: scale(1.128);
      animation: gone 0.5s 0.3s ease;
      animation-fill-mode: forwards;
    }

    ~ .recording {
      opacity: 1;
      transform: scale(0.98);
      transition-delay: 0.3s;
    }
  }

  @keyframes spinning {
    to { transform: rotatez(360deg); }
  }

  @keyframes gone {
    to {
      transform: scale(0.5);
      opacity: 0;
    }
  }

  @keyframes recording {
    0% { transform: translatey(0%); }
    30% { transform: translatey(-30%); }
    60% { transform: translatey(30%); }
    90% { transform: translatey(0%); }
  }

  @keyframes dash {
    from { stroke-dashoffset: 300; }
    to {
      stroke-dashoffset: 0;
    }
  }
.chat-input-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f1f1f1;
  border-bottom-left-radius: 0.35rem;
  border-bottom-right-radius: 0.35rem;

  .chat-input-options {
    display: flex;
    gap: 7px;
    margin-right: 1.0rem;
    margin-bottom: 0.25rem;
    font-size: 18px;
    color: #AAB2BD;
    cursor: pointer;

    .chat-input-option {
      cursor: pointer;
    }

    .selected {
      color: #006a5b !important;
    }
  };

  .chat-input-message-box {
    display: flex;
    flex-direction: column;
    padding: 1rem;
  };

  .chat-input-actions-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1.25rem;
    background-color: #eceff1;
    border-top: 1px solid #cfd8dc;
    border-bottom-left-radius: 0.35rem;
    border-bottom-right-radius: 0.35rem;

    .chat-input-actions {
      display: flex;
      gap: 1rem;
      align-items: center;

      span {
        cursor: pointer;
      };
    };
  };

  .chat-input-group {
    .input-group-text {
      background-color: #fff;
    }

    textarea {
      border-left: none;
      border-right: none;
    }
  }

  .dropzone-container {
    background: #f7fafc;
    border: 1px solid #e2e8f0;
    width: 500px !important;
    height: 500px !important;
    border: 2px dashed;
  border-color: #9e9e9e;
  }

  .hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
  };

  .file-label {
    display: flex;
    padding: 40px;
    font-size: 20px;
    cursor: pointer;
  };

  .preview-container {
    display: flex;
    margin-top: 2rem;
  }

  .preview-card {
    display: flex;
    border: 1px solid #a2a2a2;
    padding: 5px;
    margin-left: 5px;
  }

  .fileInput {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
    width: 120px;
    border: 2px dashed #a2a2a2;
    border-radius: 5px;
  }

  .preview-img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #a2a2a2;
    background-color: #a2a2a2;
  };

}

.holder {
  display: flex;
  flex-direction: column;
  align-items: center;

  .get-it-on-github {
    margin-top: 24px;
    margin-bottom: 24px;
    font-family: 'Roboto';
    color: #55606E;
  }
}

.audio.green-audio-player {
  width: 400px;
  min-width: 300px;
  height: 56px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .07);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 4px;
  user-select: none;
  -webkit-user-select: none;
  background-color: #fff;
  .play-pause-btn {
    display: none;
    cursor: pointer;
  }
  .spinner {
    width: 18px;
    height: 18px;
    background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/355309/loading.png);
    background-size: cover;
    background-repeat: no-repeat;
    animation: spin 0.4s linear infinite;
  }
  .slider {
    flex-grow: 1;
    background-color: #D8D8D8;
    cursor: pointer;
    position: relative;
    .progress {
      background-color: #44BFA3;
      border-radius: inherit;
      position: absolute;
      pointer-events: none;
      .pin {
        height: 16px;
        width: 16px;
        border-radius: 8px;
        background-color: #44BFA3;
        position: absolute;
        pointer-events: all;
        box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.32);
      }
    }
  }
  .controls {
    font-size: 16px;
    line-height: 18px;
    color: #55606E;
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
    margin-left: 24px;
    margin-right: 24px;
    .slider {
      margin-left: 16px;
      margin-right: 16px;
      border-radius: 2px;
      height: 4px;
      .progress {
        width: 0;
        height: 100%;
        .pin {
          right: -8px;
          top: -6px;
        }
      }
    }
    span {
      cursor: default;
    }
  }
  .volume {
    position: relative;
    .volume-btn {
      cursor: pointer;
      &.open path {
        fill: #44BFA3;
      }
    }
    .volume-controls {
      width: 30px;
      height: 135px;
      background-color: rgba(0, 0, 0, 0.62);
      border-radius: 7px;
      position: absolute;
      left: -3px;
      bottom: 52px;
      flex-direction: column;
      align-items: center;
      display: flex;
      &.hidden {
        display: none;
      }
      .slider {
        margin-top: 12px;
        margin-bottom: 12px;
        width: 6px;
        border-radius: 3px;
        .progress {
          bottom: 0;
          height: 100%;
          width: 6px;
          .pin {
            left: -5px;
            top: -8px;
          }
        }
      }
    }
  }
}
svg, img {
  display: block;
}

html, body {
  height: 100%;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F8FFAE;
  background: -webkit-linear-gradient(-65deg, #43C6AC, #F8FFAE);
  background: linear-gradient(-65deg, #43C6AC, #F8FFAE);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@keyframes spin {
  from {
    transform: rotateZ(0);
  }
  to {
    transform: rotateZ(1turn);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/ChatInput.vue